/**
 @typedef vue_catalog
 @type {object}
 */
/**
 @typedef js_vars
 @type {object}
 */
/**
 @typedef vue_carousel
 @type {object}
 */

import carousel_init from './carousel';
import catalog_init from './catalog';
import './plugins/vuemq';
import Vue from "vue";

if (process.env.NODE_ENV === 'production') {
    Vue.config.errorHandler = function (err, vm, info) {
        console.log(err);
        import(/* webpackChunkName: "axios" */ './axios/axiosbootstrap').then(module => {
            var axios = module.default;

            const data = {
                browser: {
                    'appVersion': window.navigator.appVersion
                },
                error: {
                    'message': err.message,
                    'stack': err.stack
                },
                vm: {
                    'data': vm.$data
                },
                info: info
            };
            axios({
                url: 'js-errors',
                data: data,
            }).then((response) => {
                switch (response.status) {
                    case 200:
                        break;
                    case 302 || 301:
                        window.location.replace(response.headers['x-redirect']);
                        break;
                    default:
                        break;
                }
            });
        });
    };
}

window.cart_set = function (products) {
    if (typeof window.cart === 'undefined') {
        import(/* webpackChunkName: "cart" */ './cart').then(module => {
            var cart_init = module.default;
            cart_init(document.documentElement.lang, [], vue_catalog.combinations, js_vars.links.checkout);
            window.cart.products = products;
        });
    } else {
        window.cart.products = products;
    }
    window.catalog.cartItems = products;
};
if(typeof vue_carousel !== 'undefined') {
    carousel_init(
        vue_carousel
    );
}

catalog_init(
    document.documentElement.lang, vue_catalog, js_vars.links.checkout
);